import { useSelector } from 'react-redux'
import { actorNames } from '../../../../commonComponents/utils'

export const Seller = ({ renderForm }) => {
  const dataSource = useSelector((state) => state.Actor.seller)
  return renderForm
    ? renderForm({
        actorType: 'seller',
        boxNumber: '14',
        actorName: actorNames.sellerName,
        dataSource: dataSource
      })
    : null
}
